import { isProduction } from "@/utils/constants";

export const setupSentryUser = data => {
  window.Sentry && window.Sentry.configureScope(scope => {
    scope.setUser(data);
  });
};
